"use strict"; //================================================================ 

/** @module std */
//================================================================
// <iterator>
//
// @reference http://www.cplusplus.com/reference/iterator
// @author Jeongho Nam <http://samchon.org>

function __export(m) {
  for (var p in m) {
    if (!exports.hasOwnProperty(p)) exports[p] = m[p];
  }
}

Object.defineProperty(exports, "__esModule", {
  value: true
});

__export(require("./InsertIterator"));

__export(require("./FrontInsertIterator"));

__export(require("./BackInsertIterator"));

__export(require("./factory"));

__export(require("./global"));